import { defaultColumns, defaultSort } from '../../components/representativeProcesses/tasks/columns';

export default {
  state: {
    tasks: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'start_date',
      order: 'ascending',
    },
  },
  getters: {
    tasks: state => state.tasks,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setTasks(state, tasks) {
      state.tasks = tasks;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/task-list');
        if (setting.id) {
          const tableConfig = {
            id: setting.id,
            type: 'task-list',
            columns: JSON.parse(setting.config).columns,
            sort: JSON.parse(setting.config).sort,
          };
          commit('setTableConfig', tableConfig);
        } else {
          const tableConfig = {
            type: 'task-list',
            columns: defaultColumns,
            sort: defaultSort,
          };
          commit('setTableConfig', tableConfig);
        }
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const tasks = await axios.get('api/tasks' + (query || ''));
        commit('setTasks', tasks);
      } catch (e) {
        console.log(e);
      }
      commit('setLoading', false);
    },
    async fetch({ commit }, id) {
      return await axios.get(`api/tasks/${id}`);
    },
    async create({ commit }, payLoad) {
      await axios.post('api/tasks', payLoad);
    },
    async update({ commit }, payLoad) {
      await axios.put('api/tasks', payLoad);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/tasks/${id}`);
    },
  },
};
